import { useCallback, useEffect } from 'react';

interface UseScrollOptions {
    direction?: 'top' | 'bottom';
    behavior?: ScrollBehavior;
}

type UseScroll = (ref: React.RefObject<HTMLDivElement>, options?: UseScrollOptions, deps?: any[]) => void;

export const useScroll: UseScroll = (ref, options, deps = []) => {
    const handleScroll = useCallback(() => {
        if (!ref.current) return;

        const scrollOptions: ScrollToOptions = {
            behavior: options?.behavior || 'smooth',
            top: options?.direction === 'top' ? 0 : ref.current.scrollHeight
        };

        ref.current.scrollTo(scrollOptions);
    }, [ref, options?.direction, options?.behavior]);

    useEffect(() => {
        handleScroll();

        // FIXME: This is a hack to make sure the scroll is done after the component is rendered
        setTimeout(() => {
            handleScroll();
        }, 100);
    }, [handleScroll, ref, ...deps]);
};
